import React, { useEffect, useState } from "react";
import CustomModal from "../common/CustomModal";
import "../../styles/Concern.css";
import api from "../../api/config";
import { toast } from "react-toastify";
import { validateCommunityDetails } from "../../validators/community/AddCommunity";
import axios from "axios";
import { STATES } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faXmark } from "@fortawesome/free-solid-svg-icons";

const CommunityModal = ({
  handleClose,
  show,
  loadMore,
  businessList,
  setIsNewCommunity,
  form,
  setForm,
  setEdit,
  media,
}) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    categoryId: "",
    state: "",
    city: "",
    description: "",
  });
  const [editMedia, setEditMedia] = useState(null);
  const [removedImgIds, setRemovedImgIds] = useState([]);
  const [formDetails, setFormDetails] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);

  useEffect(() => {
    if (isSubmitting) {
      validateForm();
    }
  }, [form]);

  const validateForm = () => {
    const newErrors = {
      categoryId: validateCommunityDetails(form.categoryId, "categoryId"),
      city: validateCommunityDetails(form?.city, "city"),
      state: validateCommunityDetails(form?.state, "state"),
      description: validateCommunityDetails(form?.description, "description"),
    };

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImages(selectedFiles);
  };

  const handleRemoveThumbnail = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);

    const updatedThumbnails = [...thumbnails];
    updatedThumbnails.splice(index, 1);
    setThumbnails(updatedThumbnails);
  };

  const handleRemoveImage = (index) => {
    const updatedEditMedia = [...editMedia];
    updatedEditMedia.splice(index, 1);
    const removedImg = editMedia[index].id;
    setRemovedImgIds((prev) => [...prev, removedImg]);
    setEditMedia(updatedEditMedia);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setLoading(true);
    const isFormValid = validateForm();
    if (isFormValid) {
      setIsSubmitting(false);
      const formData = new FormData();
      console.log(setEdit, images,form);
      if (setEdit) {
        const updatedForm = {
          ...form,
          communityFeedId: media?.communityFeedId,
          userId: media?.user?.userId,
          status: "ACTIVE",
          feedMediaIds: removedImgIds,
        };
        formData.append("data", JSON.stringify(updatedForm));
        if (images.length > 0) {
          images.forEach((image, index) => {
            formData.append(`files`, image);
          });
        }
        setFormDetails(formData);
      } else {
        const removeEmptyValues = (obj) => {
          return Object.fromEntries(
              Object.entries(obj).filter(([_, value]) => value !== null && value !== "")
          );
        };
        const newFormData = removeEmptyValues(form);
        formData.append("data", JSON.stringify(newFormData));
        if (images.length > 0) {
          images.forEach((image, index) => {
            formData.append(`files`, image);
          });
        }
      }

      try {
        if (setEdit) {
          const token = localStorage.getItem("token");
          let data = localStorage.getItem("data");
          data = JSON.parse(data);
          const response = await axios.post(
            `https://yelospace.com/api/update-community-feed`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${data?.jwt}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );

          // const response = await api.post("/update-community-feed", formData);
          console.log("response: ", response);
          if (response.status === 200) {
            toast.success("Updated Successfully");
            loadMore(0);
            setForm({
              ...form,
              categoryId: "",
              state: "",
              city: "",
              description: "",
            });
            setImages(() => []);
            setThumbnails(null);
            setEditMedia(null);
            setRemovedImgIds(()=>[])
            handleClose();
          }
        } else {
          setIsNewCommunity(true);
          const response = await api.post("/create-community-feed", formData);
          if (response.status === 200) {
            toast.success("Submitted Successfully");
            loadMore(0);
            setForm({
              ...form,
              categoryId: "",
              state: "",
              city: "",
              description: "",
            });
            setImages(() => []);
            setThumbnails(null);
            setEditMedia(null);
            setRemovedImgIds(()=>[])
            handleClose();
          }
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setIsNewCommunity(false);
        setLoading(false);
      }
    }
    setLoading(false);
    setIsSubmitting(false);
  };

  const fetchCitiesByState = async () => {
    try {
      const response = await axios.post(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        {
          country: "United States",
          state: form?.state,
        }
      );
      console.log(response, "cities*****");
      setCities(response?.data?.data);
    } catch (error) {
      toast.error("Error fetching states");
    }
  };

  useEffect(() => {
    if (!!form?.state) {
      fetchCitiesByState();
    }
    setCities([]);
    setForm({ ...form, city: "" });
  }, [form.state]);

  useEffect(() => {
    setEditMedia(media?.communityFeedMedia);
  }, [media?.communityFeedMedia]);

  useEffect(() => {
    setForm({
      ...form,
      city: media.city,
    });
  }, [cities]);

  useEffect(() => {
    //console.log"images>> ", images);
    const newThumbnails = images.map((file) => {
      return URL.createObjectURL(file);
    });
    setThumbnails(newThumbnails);
  }, [images]);

  const closeModelHandler = () => {
    loadMore(0);
    setForm({
      ...form,
      categoryId: "",
      state: "",
      city: "",
      description: "",
    });
    setImages(() => []);
    setThumbnails(null);
    setEditMedia(null);
    setRemovedImgIds(()=>[])
    handleClose();
  }

  return (
    <>
      <CustomModal
        headingTitle="Add Your Concern"
        handleClose={closeModelHandler}
        show={show}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <select
              id="businessType"
              name="categoryId"
              value={form.categoryId}
              onChange={(e) => handleChange(e)}
              className="concern-input"
            >
              <option value="">Business Type</option>
              {businessList
                ?.filter((item) => item?.name !== "General")
                ?.map((item) => (
                  <option key={item?.id} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
            </select>
            {errors.categoryId && (
              <div className="text-danger">{errors.categoryId}</div>
            )}
          </div>
          <div className="d-flex form-group side-by-side gap-4">
            <select
              id="state"
              name="state"
              value={form.state}
              onChange={(e) => handleChange(e)}
              className="concern-input"
            >
              <option value="">State</option>
              {STATES?.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
            {errors.state && <div className="text-danger">{errors.state}</div>}
            <select
              id="city"
              name="city"
              value={form.city}
              onChange={(e) => handleChange(e)}
              className="concern-input"
              disabled={!cities?.length ? true : false}
            >
              <option value="">City</option>
              {cities?.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
            {errors.city && <div className="text-danger">{errors.city}</div>}
          </div>
          <div className="form-group">
            <label
              htmlFor="media"
              style={{
                background: "#d9d9d9",
                padding: "5px 10px",
                width: "100%",
                border: "1px solid #ccc",
                borderRadius: "5px",
                // fontFamily: "system-ui",
                fontSize: "16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "unset"
              }}
            >
              Click here to upload media file(s)
              <FontAwesomeIcon
                icon={faPaperclip}
                style={{
                  borderRadius: "50%",
                  color: "#000000",
                  border: "none",
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  fontSize: "10px",
                  fontWeight: "unset"
                }}
              />
            </label>


            <input
              type="file"
              name="images"
              multiple
              accept="image/png,image/jpeg,image/jpg,video/mp4,video/quicktime"
              id="media"
              onChange={handleFileChange}
              placeholder="Add Media(s) * "
              style={{ visibility: "hidden" }}
            />
          </div>
          {thumbnails && thumbnails.length > 0 && (
            <div>
              {thumbnails.map((thumbnail, idx) => (
                <div
                  key={idx}
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginRight: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {images[idx]?.type.startsWith("video") ? (
                      <video
                        width="60"
                        height="60"
                        controls
                        style={{
                          objectFit: "cover",
                        }}
                      >
                        <source src={thumbnail} type={images[idx].type} />
                      </video>
                    ) : (
                      <img
                        src={thumbnail}
                        alt="mediafile"
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>
                  <FontAwesomeIcon
                    key={idx}
                    icon={faXmark}
                    onClick={() => handleRemoveThumbnail(idx)}
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      backgroundColor: "#8a87871f",
                      borderRadius: "50%",
                      color: "white",
                      border: "none",
                      width: "15px",
                      height: "15px",
                      cursor: "pointer",
                      fontSize: "10px",
                    }}
                  />
                </div>
              ))}
            </div>
          )}
          {setEdit && editMedia && (
            <>
              {
                editMedia.length > 0 &&
                editMedia?.map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {item.fileName.includes(".mp4") ? (
                        <video
                          controls
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                          src={item?.url}
                        />
                      ) : (
                        <img
                          src={item?.url}
                          alt="mediafile"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>

                    <FontAwesomeIcon
                      key={idx}
                      icon={faXmark}
                      onClick={() => handleRemoveImage(idx)}
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        backgroundColor: "#8a87871f",
                        borderRadius: "50%",
                        color: "white",
                        border: "none",
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                        fontSize: "10px",
                      }}
                    />
                  </div>
                ))}
            </>
          )}

          <div className="form-group">
            <textarea
              id="question"
              name="description"
              value={form.description}
              onChange={(e) => handleChange(e)}
              placeholder="Ask Your Question / Query"
              className="concern-input"
              maxLength={1000}
              rows={6}
            />
            {errors.description && (
              <div className="text-danger">{errors.description}</div>
            )}
          </div>
        </form>
      </CustomModal>
    </>
  );
};

export default CommunityModal;
